import { render, staticRenderFns } from "./PurchaseButtonNew.vue?vue&type=template&id=5c0a20e6&"
import script from "./PurchaseButtonNew.vue?vue&type=script&lang=js&"
export * from "./PurchaseButtonNew.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseButtonNew.vue?vue&type=style&index=0&id=5c0a20e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartBookButtonNew: require('/opt/build/repo/components/Cart/BookButtonNew.vue').default})
